import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Model_Input_Search_Fields: {[id:string]: ISearchProviderField} = {
    WB_MODEL_INPUT_ID:         {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Model Input Id',       columnResourceName: 'colId',          alignment: HorizAlignment.Left},  domainOptions: {}},
    MODEL_INPUT_NAME:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Model Input Name',        columnResourceName: 'colName',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    MODEL_INPUT_ID:            {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Model Input ID',          columnResourceName: 'colPId',         alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    AGGREGATION_METHOD:        {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Aggregation Method',      columnResourceName: 'colAgrMed',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50, domainIds: "PredictorAggregationMethod", useIdAsKey: true}},
    NUMBER_TYPE:               {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Number Type',             columnResourceName: 'colNumberType',  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50, domainIds: "PredictorNumberType", useIdAsKey: true}},
    SORT_ORDER_UI:             {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'Sort Order'       ,       columnResourceName: 'colSort',        alignment: HorizAlignment.Right},  domainOptions: {}},
    INPUT_FIELDNAME:           {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Field Name',              columnResourceName: 'colFieldName',   alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    COMMENTS:                  {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Comments',                columnResourceName: 'colComments',    alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const ModelInputSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_MODEL_INPUT_ID',
                id_ui: 'MODEL_INPUT_ID',
                name: 'MODEL_INPUT_NAME'

    },

    searchProviderFields: vUI_Model_Input_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Model_Input_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res:any)=>{
                    resolve(res)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }
};

const ModelInputSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "ModelInputSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'MODEL_INPUT_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'MODEL_INPUT_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'MODEL_INPUT_NAME', 'SORT_ORDER_UI', 'NUMBER_TYPE', 'AGGREGATION_METHOD', 'INPUT_FIELDNAME', 'MODEL_INPUT_ID','COMMENTS',
        "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelInputSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ModelInputSearch: ISearch = {
    searchName: "Find Model Input",
    renderOptions: {ui5ResourceId: "ModelInputSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ModelInputSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ModelInputBO", "ModelInput", ModelInputSearch, "Model Input Search")

export {ModelInputSearch}
